export enum DataRepresentation {
    TABLE = 'table',
    SPIDER_CHART = 'spiderChart',
    HORIZONTAL_BAR_CHART = 'horizontalBarChart',
    SHARE_DONUT_CHART = 'shareDonutChart',
    SHARE_RECOMMENDATION_TABLE = 'shareRecommendationTable',
}
